import { REMOVE_REPEATER_ITEM, REMOVE_REPEATER_ITEM_REVIEW } from './';

export default (key, index) => (dispatch, getState) => {
  const { form: { selectedForm: { isActive } = {} } = {} } = getState();
  dispatch({
    type: isActive ? REMOVE_REPEATER_ITEM : REMOVE_REPEATER_ITEM_REVIEW,
    payload: { key, index },
  });
};
